import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";
import { Divider } from "primereact/divider";
import { ProgressSpinner } from "primereact/progressspinner";

const apiUrl = process.env.REACT_APP_API_URL;

export const ModifierContrat = ({ setModifierCtr, idPSelected }) => {
  const toast = React.useRef(null);
  const [ctrData, setCtrData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Contrat 1
  const [lienContrat, setLienContrat] = useState("");
  const [typeContrat, setTypeContrat] = useState("");
  const [typeCaution, setTypeCaution] = useState("");
  const [noteContrat, setNoteContrat] = useState("");
  const [dateCtr, setDateCtr] = useState(null);

  // Contrat 2 (nouveau)
  const [hasSecondContrat, setHasSecondContrat] = useState(false);
  const [lienContrat2, setLienContrat2] = useState("");
  const [dateCtr2, setDateCtr2] = useState(null);

  const [idLocation, setIdLocation] = useState("");
  const [idClient, setIdClient] = useState("");
  const [nomCompl, setNomCompl] = useState("");
  const [num, setNum] = useState("");
  const [mail, setMail] = useState("");
  const [adresse, setAdresse] = useState("");

  useEffect(() => {
    if (idPSelected) {
      setLoading(true);
      axios
        .post(`${apiUrl}IHM/api/contrat.php?idModifSelect=${idPSelected}`)
        .then((response) => {
          const data = response.data;
          setCtrData(data);
          const ctr = data[0];
          
          if (ctr) {
            const adresse = `${ctr.ville || ''} - ${ctr.codePostal || ''} - ${ctr.adresse || ''}`;
            const num = `${ctr.num1 || ''} - ${ctr.num2 || ''}`;

            setIdLocation(ctr.idLocation);
            setIdClient(ctr.idClient);
            setNomCompl(ctr.nom);
            setNum(num);
            setMail(ctr.mail);
            setAdresse(adresse);
            setTypeContrat(ctr.typeContrat);
            setTypeCaution(ctr.caution);
            
            setDateCtr(ctr.dateContrat ? new Date(ctr.dateContrat) : null);
            setLienContrat(ctr.lienCtr || "");
            setNoteContrat(ctr.noteCtr || "");
            
            if (ctr.lienCtr2 || ctr.dateContrat2) {
              setHasSecondContrat(true);
              setLienContrat2(ctr.lienCtr2 || "");
              setDateCtr2(ctr.dateContrat2 ? new Date(ctr.dateContrat2) : null);
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Erreur:", error);
          setLoading(false);
        });
    }
  }, [idPSelected]);

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };

  const faireModification = async (e) => {
    e.preventDefault();

    const data = {
      idContrat: idPSelected,
      typeContrat: typeContrat,
      dateContrat: formatDate(dateCtr),
      caution: typeCaution,
      infoUpdate: localStorage.getItem('us'),
      lienCtr: lienContrat,
      noteCtr: noteContrat,
      lienCtr2: hasSecondContrat ? lienContrat2 : null,
      dateContrat2: hasSecondContrat ? formatDate(dateCtr2) : null,
    };

    try {
      await axios.post(`${apiUrl}IHM/api/contrat.php`, data);
      toast.current.show({
        severity: 'success',
        summary: 'Succès',
        detail: 'Contrat modifié avec succès',
        life: 3000
      });
      setTimeout(() => {
        setModifierCtr(false);
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error("Erreur:", error);
      toast.current.show({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Erreur lors de la modification',
        life: 3000
      });
    }
  };

  const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg">Modifier le contrat</span>
     
    </div>
  );

  return (
    <>
      <Toast ref={toast} />

      <Dialog
        blockScroll
        visible={true}
        header={header}
        className="custom-dialog"
        style={{ width: "50vw", maxWidth: "700px" }}
        modal
        onHide={() => setModifierCtr(false)}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        {loading ? (
          <div className="flex justify-content-center p-5">
            <i
              className="pi pi-spin pi-spinner"
              style={{ fontSize: "2rem", color: "#2563eb" }}
            ></i>
          </div>
        ) : (
          <div className="p-3">
            {/* Section 1 - Informations client */}
            <div className="grid">
              <div className="col-12">
                <div
                  style={{
                    background: "#f3f4f6",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <span
                    style={{
                      background: "#374151",
                      color: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: 700,
                    }}
                  >
                    1
                  </span>
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#374151",
                      letterSpacing: "0.05em",
                    }}
                  >
                    INFORMATIONS CLIENT
                  </span>
                </div>
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  ID Location
                </label>
                <input
                  value={idLocation}
                  disabled
                  style={{
                    width: "100%",
                    height: "36px",
                    padding: "0 8px",
                    border: "1px solid #d1d5db",
                    borderRadius: "5px",
                    background: "#f9fafb",
                    fontSize: "14px",
                  }}
                />
              </div>
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Client
                </label>
                <input
                  value={`${idClient} - ${nomCompl}`}
                  disabled
                  style={{
                    width: "100%",
                    height: "36px",
                    padding: "0 8px",
                    border: "1px solid #d1d5db",
                    borderRadius: "5px",
                    background: "#f9fafb",
                    fontSize: "14px",
                  }}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Email
                </label>
                <input
                  value={mail}
                  disabled
                  style={{
                    width: "100%",
                    height: "36px",
                    padding: "0 8px",
                    border: "1px solid #d1d5db",
                    borderRadius: "5px",
                    background: "#f9fafb",
                    fontSize: "14px",
                  }}
                />
              </div>
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Téléphone
                </label>
                <input
                  value={num}
                  disabled
                  style={{
                    width: "100%",
                    height: "36px",
                    padding: "0 8px",
                    border: "1px solid #d1d5db",
                    borderRadius: "5px",
                    background: "#f9fafb",
                    fontSize: "14px",
                  }}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Adresse
                </label>
                <input
                  value={adresse}
                  disabled
                  style={{
                    width: "100%",
                    height: "36px",
                    padding: "0 8px",
                    border: "1px solid #d1d5db",
                    borderRadius: "5px",
                    background: "#f9fafb",
                    fontSize: "14px",
                  }}
                />
              </div>
            </div>

            {/* Section 2 - Contrat principal */}
            <div className="grid mt-3">
              <div className="col-12">
                <div
                  style={{
                    background: "#f3f4f6",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <span
                    style={{
                      background: "#374151",
                      color: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: 700,
                    }}
                  >
                    2
                  </span>
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#374151",
                      letterSpacing: "0.05em",
                    }}
                  >
                    CONTRAT PRINCIPAL
                  </span>
                </div>
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Type de contrat
                </label>
                <select
                  value={typeContrat}
                  onChange={(e) => setTypeContrat(e.target.value)}
                  style={{
                    width: "100%",
                    height: "36px",
                    padding: "0 8px",
                    border: "1px solid #d1d5db",
                    borderRadius: "5px",
                    fontSize: "13px",
                    background: "white",
                  }}
                >
                  <option value="CNS">Contrat non signé (CNS)</option>
                  <option value="CS">Contrat signé (CS)</option>
                  <option value="CE">Contrat envoyé (CE)</option>
                  <option value="PDC">Pas de contrat (PDC)</option>
                </select>
              </div>
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Caution / docs
                </label>
                <select
                  value={typeCaution}
                  onChange={(e) => setTypeCaution(e.target.value)}
                  style={{
                    width: "100%",
                    height: "36px",
                    padding: "0 8px",
                    border: "1px solid #d1d5db",
                    borderRadius: "5px",
                    fontSize: "13px",
                    background: "white",
                  }}
                >
                  <option value="oui">Oui</option>
                  <option value="non">Non</option>
                </select>
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Lien du contrat
                </label>
                <input
                  value={lienContrat}
                  onChange={(e) => {
                    setLienContrat(e.target.value);
                    if (e.target.value.includes("https://drive")) {
                      setTypeContrat("CS");
                    }
                  }}
                  placeholder="https://..."
                  style={{
                    width: "100%",
                    height: "36px",
                    padding: "0 8px",
                    border: "1px solid #d1d5db",
                    borderRadius: "5px",
                    fontSize: "14px",
                  }}
                />
              </div>
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Date du contrat
                </label>
                <input
                  type="date"
                  value={dateCtr ? dateCtr.toISOString().split('T')[0] : ''}
                  onChange={(e) => setDateCtr(e.target.value ? new Date(e.target.value) : null)}
                  style={{
                    width: "100%",
                    height: "36px",
                    padding: "0 8px",
                    border: "1px solid #d1d5db",
                    borderRadius: "5px",
                    fontSize: "14px",
                  }}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Note
                </label>
                <textarea
                  value={noteContrat}
                  onChange={(e) => setNoteContrat(e.target.value)}
                  rows={2}
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #d1d5db",
                    borderRadius: "5px",
                    fontSize: "14px",
                    fontFamily: "inherit",
                    resize: "vertical",
                  }}
                />
              </div>
            </div>

            {/* Section 3 - Contrat secondaire */}
            <div className="grid mt-3">
              <div className="col-12">
                {!hasSecondContrat ? (
                  <button
                    onClick={() => setHasSecondContrat(true)}
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px dashed #d1d5db",
                      borderRadius: "5px",
                      background: "transparent",
                      fontSize: "14px",
                      color: "#374151",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                    }}
                  >
                    <span style={{ fontSize: "20px" }}>+</span> Ajouter un deuxième contrat
                  </button>
                ) : (
                  <>
                    <div
                      style={{
                        background: "#f3f4f6",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        marginBottom: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <span
                          style={{
                            background: "#374151",
                            color: "white",
                            borderRadius: "50%",
                            width: "18px",
                            height: "18px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "11px",
                            fontWeight: 700,
                          }}
                        >
                          3
                        </span>
                        <span
                          style={{
                            fontSize: "11px",
                            fontWeight: 600,
                            color: "#374151",
                            letterSpacing: "0.05em",
                          }}
                        >
                          CONTRAT SECONDAIRE
                        </span>
                      </div>
                      <button
                        onClick={() => {
                          setHasSecondContrat(false);
                          setLienContrat2("");
                          setDateCtr2(null);
                        }}
                        style={{
                          border: "none",
                          background: "transparent",
                          color: "#ef4444",
                          cursor: "pointer",
                          fontSize: "16px",
                        }}
                      >
                        ✕
                      </button>
                    </div>

                    <div className="grid">
                      <div className="col-12 md:col-6">
                        <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                          Lien du contrat 2
                        </label>
                        <input
                          value={lienContrat2}
                          onChange={(e) => setLienContrat2(e.target.value)}
                          placeholder="https://..."
                          style={{
                            width: "100%",
                            height: "36px",
                            padding: "0 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "5px",
                            fontSize: "14px",
                          }}
                        />
                      </div>
                      <div className="col-12 md:col-6">
                        <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                          Date du contrat 2
                        </label>
                        <input
                          type="date"
                          value={dateCtr2 ? dateCtr2.toISOString().split('T')[0] : ''}
                          onChange={(e) => setDateCtr2(e.target.value ? new Date(e.target.value) : null)}
                          style={{
                            width: "100%",
                            height: "36px",
                            padding: "0 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "5px",
                            fontSize: "14px",
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Bouton enregistrer */}
            <div className="grid mt-3">
              <div className="col-12">
                <Button
                  label="Enregistrer les modifications"
                  icon="pi pi-check"
                  className="w-full"
                  style={{
                    background: "#dbeafe",
                    border: "1px solid #bfdbfe",
                    padding: "0.75rem",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: 500,
                    justifyContent: "center",
                    gap: "8px",
                    color: "#1d4ed8",
                  }}
                  onClick={faireModification}
                />
              </div>
            </div>
          </div>
        )}
      </Dialog>
    </>
  );
};